import connectionProxy from './connectionProxy'

export const getInventoryInputList = object => 
  {
    const text = encodeURIComponent(object.searchText)
    return connectionProxy.http.get(
      `/estoque/entradas?term=${text}&area_id=${object.areaId}&page=${object.page}&per_page=${object.rowsPerPage}&order_by=${object.orderBy}&order=${object.order}`
    )
  }

const config = {
  headers: {
    'content-type': 'multipart/form-data'
  }
}

export const getProductHistoric = object => {
  return connectionProxy.http.get(
    `estoque/historico_do_produto?product_id=${object.product_id}&batch=${object.batch}&area_id=${object.areaId}&page=${object.page}&per_page=${object.rowsPerPage}&order_by=${object.orderBy}&order=${object.order}`
  )
}

export const addInventoryInput = inventory =>
  connectionProxy.http.post(`/estoque/entrada`, { inventory }, { config })

export const addInventoryOutput = inventory =>
  connectionProxy.http.post(`/estoque/saida`, { inventory })

export const editInventoryInput = (inventory, area_id) =>
  connectionProxy.http.put(`/estoque/editar`, { inventory, area_id }, { config })

export const editInventoryOutput = inventory =>
  connectionProxy.http.put(`/estoque/editar-saida`, { inventory })

export const getProductBatches = (productId, areaId) =>
  connectionProxy.http.get(`/estoque/lotes?product_id=${productId}&area_id=${areaId}`)

export const getBatch = (productId, areaId, batch) =>
  connectionProxy.http.get(`/estoque/lote?product_id=${productId}&area_id=${areaId}&batch=${batch}`)

export const downloadXls = (searchText, areaId) =>
    connectionProxy.http.get(`/estoque/download_estoque_xls?term=${searchText}&area_id=${areaId}`, {
      responseType: 'arraybuffer'
    })

export const downloadPdf = (searchText, areaId) =>
  connectionProxy.http.get(`/estoque/download_estoque_pdf?term=${searchText}&area_id=${areaId}`, {
    responseType: 'arraybuffer'
  })

export const getInventoryHistoric = ({ areaId, page, rowsPerPage, orderBy, order, searchText }) =>
  connectionProxy.http.get(
    `/estoque/historico_movimentacao?area_id=${areaId}&page=${page}&per_page=${rowsPerPage}&order_by=${orderBy}&order=${order}&q=${searchText}`
  )

export const getDownloadHistoricXLS = areaId =>
  connectionProxy.http.get(`/estoque/download_historico_xls?area_id=${areaId}`, {
    responseType: 'arraybuffer'
  })

export const getDownloadHistoricPDF = areaId =>
  connectionProxy.http.get(`/estoque/download_historico_pdf?area_id=${areaId}`, {
    responseType: 'arraybuffer'
  })

export const getDownloadProductHistoricXLS = (areaId, productId, batch) =>
  connectionProxy.http.get(
    `/estoque/download_historico_produto_xls?area_id=${areaId}&product_id=${productId}&batch=${batch}`,
    {
      responseType: 'arraybuffer'
    }
  )

export const getDownloadProductHistoricPDF = (areaId, productId, batch) =>
  connectionProxy.http.get(
    `/estoque/download_historico_produto_pdf?area_id=${areaId}&product_id=${productId}&batch=${batch}`,
    {
      responseType: 'arraybuffer'
    }
  )

export const getDownloadProductInventoryHistoricXLS = (areaId, productId, initial_date = '', final_date = '') => 
  connectionProxy.http.get(
    `/estoque/download_historico_produto_estoque_xls?area_id=${areaId}&product_id=${productId}&initial_date=${initial_date}&final_date=${final_date}`,
    {
      responseType: 'arraybuffer'
    }
  )

  export const getDownloadProductInventoryHistoricPDF = (areaId, productId, initial_date = '', final_date = '') => 
  connectionProxy.http.get(
    `/estoque/download_historico_produto_estoque_pdf?area_id=${areaId}&product_id=${productId}&initial_date=${initial_date}&final_date=${final_date}`,
    {
      responseType: 'arraybuffer'
    }
  )


// WEBPACK FOOTER //
// ./src/api/inventory.js